import { SessionService } from "../../../utils/types";
import { IPracticeActiveSession } from "../../auth/types/auth.types";
import {
    ISessionConsentForm,
    IPracticeFormLink,
    IPracticeUpcomingSession,
} from "../../dashboard/types/dashboard.types";

export enum ROIForm {
    HT = "https://humantold.medforward.com/FillOutForm?formname=authorization_form__hipaa_",
    CHP = "https://humantold.medforward.com/FillOutForm?formname=carnegie_hill_authorization_form__hipaa_",
    PH = "https://humantold.medforward.com/FillOutForm?formname=park_hill_authorization_form__hipaa_",
}

export interface IUpcomingSession {
    session_id: string;
    start_date_time: string;
    end_date_time: string;
    session_history_id: string;
    booking_id?: string | null;
    payment_date?: string;
    service: SessionService;
    client_id: string;
    fee: number;
    provider: {
        provider_id: string;
        first_name: string;
        last_name: string;
        credential?: string;
        email?: string;
        contact_info_client?: string;
    };
    is_paid: boolean;
    delivery_option: string;
    supervisor?: {
        user_id: string;
        last_name: string;
        first_name: string;
    };
    location?: {
        location_name?: string;
        office_name?: string;
    };
    consent?: ISessionConsentForm;
}

export interface ISessionReadinessStep {
    id: string;
    title: string;
    description: string;
    completed: boolean;
}

export interface IPortalSessionPreview extends IPracticeActiveSession {
    fee: number;
    location_text: string;
    location_label: string;
    consent_forms: IPracticeFormLink[];
    services_link: string;
    cancellation_policy_title: string;
    cancellation_policy_preview: string;
    readiness_steps: ISessionReadinessStep[];
    next_occurrence?: IPracticeUpcomingSession & {
        session_history_id?: string;
        fee?: number;
        is_paid?: boolean;
    };
}
